import styles from './SeeAllButton.module.css'

interface SeeAllButtonProps{
    type: number;
    routertype: string;
}


function SeeAllButton({type,routertype}:SeeAllButtonProps) {

    const buttonType = type === 1 ? styles['button-type1'] :    /*projetos*/
                       type === 2 ? styles['button-type2'] :    /*extensões*/
                       type === 3 ? styles['button-type3'] :    /*participantes*/
                       null;

    const fontButton = type === 2 ? styles['font-color'] : '';
    const containertype = type === 3 ? styles['container-type3'] : '';

    return (
        <div className={`${styles.container} ${containertype}`}>
            <button type="submit" className={`${styles.button} ${buttonType}`}><a href={routertype} className={fontButton}>VER TODOS</a></button>
        </div>
    )
}

export default SeeAllButton;